import React, { useCallback, useEffect, useState } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import CompanyList from "./CompanyList";
import { receptionButtonTypeAtom, receptionCompanyIdAtom } from "~/Atom";
import { getPhoneBooksEntity } from "~/utils/receptionDB";
import { useInactivityTimeout } from "~/utils/receptionUtils";
import { ROUTE } from "~/constants/routes";
import ReceptionHeader from "~/components/ReceptionHeader";

/**
 * CompanyList画面（会社選択の可否判定・自動遷移タイマーを含む）
 */
const CompanyListPage: React.FC = () => {
  const navigate = useNavigate();
  const [, setReceptionCompanyId] = useAtom(receptionCompanyIdAtom);
  const [, setReceptionButtonType] = useAtom(receptionButtonTypeAtom);
  const [isSelectCompanyEnabled, setIsSelectCompanyEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    const fetchPhoneBook = async () => {
      try {
        const phoneBook = await getPhoneBooksEntity();
        if (!phoneBook) {
          setIsSelectCompanyEnabled(null);
          return;
        }

        setIsSelectCompanyEnabled(phoneBook.isSelectCompanyEnabled);
      } catch (err) {
        console.error("Failed to load phoneBook data:", err);
        setIsSelectCompanyEnabled(null);
      }
    };

    fetchPhoneBook();
  }, []);

  useEffect(() => {
    if (isSelectCompanyEnabled === null) return;

    if (!isSelectCompanyEnabled) {
      navigate(ROUTE.RECEPTION.LOADING, { state: { skipStartupModal: true } });
    }
  }, [isSelectCompanyEnabled, navigate]);

  useInactivityTimeout(navigate);

  const handleBack = useCallback(() => {
    navigate(ROUTE.RECEPTION.LOADING, { replace: true, state: { skipStartupModal: true } });
  }, [navigate]);

  return (
    <div className="company-list-page">
      <ReceptionHeader showBackButton onBackButtonClick={handleBack} />
      <CompanyList
        onSelectCompany={(group) => {
          setReceptionCompanyId(group.displayId);
          setReceptionButtonType("");
          navigate(ROUTE.RECEPTION.MENU);
        }}
      />
    </div>
  );
};

export default CompanyListPage;
